var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.computedClasses},[(_vm.isLoading)?_c('div',{staticClass:"tw-absolute loading"},[_c('ui-loading',{staticClass:"tw-text-8xl tw-m-auto"})],1):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }